<div class="form-group">
    <label class="input-label">Maximum value</label>
    <input class="form-control"
           name="max"
           type="number"
           [(ngModel)]="fieldOptions.validate.max">
</div>